var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillDashboardSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7414 1.53568C9.7284 0.706858 8.2716 0.706858 7.2586 1.53568L1.0086 6.64932C0.37022 7.17163 0 7.95289 0 8.7777V17.83C0 19.3488 1.23122 20.58 2.75 20.58H15.25C16.7688 20.58 18 19.3488 18 17.83V8.7777C18 7.95289 17.6298 7.17163 16.9914 6.64932L10.7414 1.53568ZM4.75 15.08C4.33579 15.08 4 15.4158 4 15.83C4 16.2442 4.33579 16.58 4.75 16.58H13.25C13.6642 16.58 14 16.2442 14 15.83C14 15.4158 13.6642 15.08 13.25 15.08H4.75Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillDashboardSelected);
export default __webpack_public_path__ + "static/media/bill-dashboard-selected.da459e9292aefb6171ebc9558a83d22e.svg";
export { ForwardRef as ReactComponent };